import React, { useCallback, useState } from 'react';
import CommonPage from 'components/podiatry/commonPage';
import {
  conditionalOptions,
  haveYouSeenOtherProviderOptions,
  whichFootOptions,
  reasonForVisitContOptions,
} from 'lib/podiatryOptions';
import DiagnosisUploadPhotoScreen from 'components/podiatry/diagnosisUploadPhotoScreen';
import HowLongExperiencingProblem from 'components/podiatry/howLongExperiencingProblem';
import { actionTypesOfReasonForVisit } from 'reducer/actionType';
import PageResult from 'components/podiatry/pageResult';
import WhatTreatmentsDidProvide from 'components/podiatry/whatTreatmentsDidProvide';
import HaveYouSeenOtherProviders from 'components/podiatry/haveYouSeenOtherProviders';
import HowLongDidPhysicalTherapy from 'components/podiatry/howLongDidPhysicalTherapy';
import WhatTypeOfPainScreen from 'components/podiatry/whatTypeOfPainScreen';
import WhichFootScreen from 'components/podiatry/whichFootScreen';
import WhatTreatmentsWereHelpful from 'components/podiatry/whatTreatmentsWereHelpful';
import CompletedReasonForVisit from 'components/podiatry/completedReasonForVisit';
import {
  usePersistRFVReducer,
} from 'reducer/reasonForVisit';
import Header from 'components/common/header';
import useBeforeUnload from 'hooks/useBeforeUnload';

function PodiatryApp() {
  const totalPage = 16;
  const [currentPage, setCurrentPage] = useState(1);
  useBeforeUnload(totalPage > currentPage);

  const [, dispatch] = usePersistRFVReducer();

  const nextOrSubmitButton = useCallback(
    (nextPage: number, submit?: boolean) => {
      if (submit) {
        if (nextPage === 200) {
          setCurrentPage(nextPage);
          return;
        }
        setCurrentPage(100);

        return;
      }
      setCurrentPage(nextPage);
    },
    [],
  );

  const pageBackButton = (pageNumber: number) => {
    if (pageNumber === 0) {
      return;
    }
    setCurrentPage(pageNumber);
  };

  return (
    <div className="app-page-container">
      <Header
        currentPage={currentPage}
        totalPage={totalPage}
        onClickBackButton={pageBackButton}
      />
      <div className="pt-36 pb-20 px-3">

        {currentPage === 1 && (
          <CommonPage
            options={reasonForVisitContOptions}
            nextPage={2}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfReasonForVisit.REASON_FOR_VISIT_CONT}
            multiple
            textFieldForOther
          />
        )}

        {currentPage === 2 && (
          <WhichFootScreen
            pageOptions={whichFootOptions}
            nextPage={3}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}

        {currentPage === 3 && (
          <DiagnosisUploadPhotoScreen
            nextPage={4}
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}

        {currentPage === 4 && (
          <HowLongExperiencingProblem
            nextPage={5}
            nextOrSubmitButton={nextOrSubmitButton}
            isFilter
            currentPage={currentPage + 1}
            options={conditionalOptions}
          />
        )}

        {currentPage === 5 && (
          <CommonPage
            options={conditionalOptions}
            nextPage={6}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfReasonForVisit.HOW_DID_IT_START}
            multiple={false}
            isFilter
            textFieldForOther
          />
        )}

        {currentPage === 6 && (
          <WhatTypeOfPainScreen
            options={conditionalOptions}
            nextPage={7}
            currentPage={currentPage}
            isFilter
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfReasonForVisit.WHAT_TYPE_OF_PAIN}
            multiple
          />
        )}

        {currentPage === 7 && (
          <CommonPage
            options={conditionalOptions}
            nextPage={8}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfReasonForVisit.WHAT_ARE_YOUR_SYMPTOMS}
            multiple
            isFilter
            textFieldForOther
            required={false}
          />
        )}

        {currentPage === 8 && (
          <CommonPage
            options={conditionalOptions}
            nextPage={9}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfReasonForVisit.PAIN_WORST}
            multiple
            isFilter
            textFieldForOther
          />
        )}
        {currentPage === 9 && (
          <CommonPage
            options={conditionalOptions}
            nextPage={10}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={
              actionTypesOfReasonForVisit.WHICH_OF_THE_FOLLOWING_CAN_YOU_NO_LONGER
            }
            multiple
            isFilter
          />
        )}
        {currentPage === 10 && (
          <CommonPage
            options={conditionalOptions}
            nextPage={11}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfReasonForVisit.TREATMENTS_TRIED_HOME}
            multiple
            isFilter
            textFieldForOther
          />
        )}
        {currentPage === 11 && (
          <HaveYouSeenOtherProviders
            nextPage={12}
            options={haveYouSeenOtherProviderOptions}
            currentPage={currentPage}
            multiple={false}
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={actionTypesOfReasonForVisit.SEEN_OTHER_PROVIDERS}
          />
        )}

        {currentPage === 12 && (
          <WhatTreatmentsDidProvide
            nextPage={13}
            options={conditionalOptions}
            currentPage={currentPage}
            isFilter
            multiple
            nextOrSubmitButton={nextOrSubmitButton}
            actionPage={
              actionTypesOfReasonForVisit.WHAT_TREATMENTS_DID_PROVIDER
            }
          />
        )}

        {currentPage === 13 && (
          <HowLongDidPhysicalTherapy
            nextPage={14}
            options={conditionalOptions}
            currentPage={currentPage}
            isFilter
            actionPage={
              actionTypesOfReasonForVisit.HOW_LONG_DID_PHYSICAL_THERAPY
            }
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {currentPage === 14 && (
          <WhatTreatmentsWereHelpful
            nextPage={15}
            options={conditionalOptions}
            currentPage={currentPage}
            isFilter
            actionPage={
              actionTypesOfReasonForVisit.WHAT_TREATMENTS_WERE_HELPFUL
            }
            nextOrSubmitButton={nextOrSubmitButton}
          />
        )}
        {/* Page result */}
        {currentPage === 100 && (
          <PageResult nextOrSubmitButton={nextOrSubmitButton} />
        )}

        {currentPage === 200 && <CompletedReasonForVisit />}
      </div>
    </div>
  );
}

export default PodiatryApp;
